import React from 'react';
import { DataGrid } from 'devextreme-react';
import { ActionBarContext } from 'utils/ActionBarContextProvider';
import { Paper, withStyles } from '@material-ui/core';
import styles from './SerialNumbers.styles';
import { ILinesHandle, ILinesProperties } from './SerialNumbers.properties';
import DynamicDataGrid from 'components/common/DataGridDevEx/DynamicDataGrid';
import { columns } from './SerialNumbers.constants';
import { useRetrieveSerialLines } from 'api/movementEnquiry/movementEnquiry';
import { createDataSource } from 'components/common/DataGridDevEx/DataGrid.hooks';
import { BACK_BUTTON } from 'components/common/ActionBar/constants';

const SerialNumbers = (props: ILinesProperties, ref: React.Ref<ILinesHandle>) => {
    const { classes } = props;
    const { setActionBar } = React.useContext(ActionBarContext);
    const params = new URLSearchParams(location.search);
    const ProductId = params.get('ProductId') || 0;
    const MovementId = params.get('MovementId') || 0;
    const LineNumber = params.get('MovementLineNo') || 0;
    const dataGridInnerRef = React.useRef<DataGrid>();
    const fetchLinesMutation = useRetrieveSerialLines();

    React.useEffect(
        () => {
            setActionBar({
                leftIcons: [BACK_BUTTON],
                centerIcons: [],
                rightIcons: []
            });
        },
        []
    );

    React.useImperativeHandle(
        ref,
        () => ({}),
        []
    );

    const fetchLines = React.useCallback(
        async (BatchPage, BatchSize, Sort) => {
            if (MovementId !== undefined) {
                try {
                    const lines = await fetchLinesMutation.mutateAsync({
                        ProductId: Number(ProductId),
                        MovementId: Number(MovementId),
                        LineNumber: Number(LineNumber),
                        urlQueryParams: {
                            BatchPage,
                            BatchSize,
                            Sort
                        }
                    });

                    return lines?.Serials ?? [];
                } catch (error) {
                    console.error('Error fetching lines:', error);

                    return null;
                }
            } else {
                return null;
            }
        },
        [MovementId, ProductId, LineNumber]
    );

    const linesDataSource = React.useMemo(
        () => createDataSource(
            'Serial',
            { fetch: fetchLines },
        ),
        [fetchLines]
    );

    return (
        <div className={classes.parentContainer}>
            <Paper className={classes.gridContainer}>
                <DynamicDataGrid
                    dataGridClassName={classes.grid}
                    columns={columns}
                    allowHeaderFilting={false}
                    allowUpdating={false}
                    actionButtonsVisibility={false}
                    gridProps={{
                        dataSource: linesDataSource,
                        dataGridRef: dataGridInnerRef,
                        sorting: { mode: 'single' },
                        disableDrillDown: true,
                        disableEditing: true,
                        disableDelete: true,
                    }}
                />
            </Paper>
        </div>
    );
};

export default withStyles(styles, { index: 1 })(React.memo(React.forwardRef(SerialNumbers)));
